import PropTypes from 'prop-types';

const savedSearchPropType = PropTypes.shape({
  id: PropTypes.number,
  subscriptionId: PropTypes.number,
  name: PropTypes.string,
  typeId: PropTypes.number,
  filters: PropTypes.arrayOf(PropTypes.shape({
    facetId: PropTypes.number,
    operatorId: PropTypes.number,
    value1: PropTypes.string,
    value2: PropTypes.string,
  })),
});

export default { savedSearchPropType };
